import {
  Divider,
  DragDrop,
  GKButton,
  GKModal,
  Grid2,
  Typography,
} from "components";
import { WebsiteDetails } from "Pages/MyWebiste/types";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { GKModalProps } from "utils/commonInterface";

const AuditFilesUpload = ({
  setOpen,
  open,
  index,
}: GKModalProps & { index: number }) => {
  const form = useFormContext<WebsiteDetails>();

  const [uploadError, setUploadError] = useState<string | null>(null);

  form.watch();

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Upload Audit Files"
      footer={
        <Grid2 size={12} display={"flex"} justifyContent={"space-between"}>
          <GKButton
            color="dark"
            variant="outlined"
            onClick={() => {
              setOpen(false);
              form.setValue(`compliance.complianceAudit.${index}.report1`, []);
              form.setValue(`compliance.complianceAudit.${index}.report2`, []);
            }}
          >
            Cancel
          </GKButton>
          <GKButton
            variant="contained"
            onClick={() => {
              setOpen(false);
            }}
          >
            Save
          </GKButton>
        </Grid2>
      }
    >
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Audit Report
          </Typography>
          <Controller
            name={`compliance.complianceAudit.${index}.report1`}
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "Please upload a document",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <DragDrop
                {...field}
                uploadError={uploadError}
                setUploadError={setUploadError}
                value={field.value}
                onChange={(e) => {
                  field.onChange(e);
                }}
                supportName=".png, .jpg, .pdf"
                acceptType={".pdf,.png,.jpg"}
                error={!!error}
              />
            )}
          />
        </Grid2>
        <Grid2 size={12}>
          <Divider />
        </Grid2>
        <Grid2 size={12}>
          <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
            Adverse Findings
          </Typography>
          <Controller
            name={`compliance.complianceAudit.${index}.report2`}
            control={form.control}
            rules={{
              required: {
                value: true,
                message: "Please upload a document",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <DragDrop
                uploadError={uploadError}
                setUploadError={setUploadError}
                {...field}
                onChange={(e) => {
                  field.onChange(e);
                }}
                supportName=".png, .jpg, .pdf"
                acceptType={".pdf,.png,.jpg"}
                error={!!error}
              />
            )}
          />
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default AuditFilesUpload;
